import { get, patch } from 'vio-libs';
export function getCarouselDevices(organization, locationSlug, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`devices-v2?organization=${organization}&location=${locationSlug}&type=carousel`);
    }
    return get(`v1/${organization}/${locationSlug}/devices?device_type=carousel`, undefined, true);
}
export function getLockDevices(organization, locationSlug, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`devices-v2?organization=${organization}&location=${locationSlug}&type=lock`);
    }
    return get(`v1/${organization}/${locationSlug}/devices?device_type=lock`, undefined, true);
}
export function setCarouselDevice(organization, locationSlug, deviceId, setting, consumerAPI = false) {
    if (!consumerAPI) {
        return patch(`devices-v2?organization=${organization}&location=${locationSlug}`, {
            data: {
                action: `{"rack":${setting}}`,
                device_id: deviceId
            }
        });
    }
    return patch(`v1/${organization}/${locationSlug}/devices/${deviceId}`, {
        data: {
            action: `{"rack":${setting}}`
        }
    }, true);
}
export function setLockDevice(organization, locationSlug, deviceId, action, consumerAPI = false) {
    if (!consumerAPI) {
        return patch(`devices-v2?organization=${organization}&location=${locationSlug}`, {
            data: {
                action,
                device_id: deviceId
            }
        });
    }
    return patch(`v1/${organization}/${locationSlug}/devices/${deviceId}`, {
        data: {
            action
        }
    }, true);
}
